import { getPricingApiConfig } from '../api/pricing-api';
import { getProductPrices, StandardPrice } from '..';
import { mapToStandardPrice } from './map-to-standard-price';

export const getSfccStandardPricesBySkus = async (skus: string[]): Promise<StandardPrice[]> => {
  const noPrices = new Array(skus.length).fill(null);
  try {
    const { isSFCCPricingOn } = getPricingApiConfig();

    if (!isSFCCPricingOn) {
      return noPrices;
    }
    const prices = await getProductPrices(skus);

    return prices ? prices.map(mapToStandardPrice) : noPrices;
  } catch (error) {
    console.error('Failed to map prices to standard price', error);
    // null prevents infinite skeleton loader animation
    return noPrices;
  }
};
